import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appointmentStatusColor]',
    standalone: false
})
export class AppointmentStatusColorDirective {

  @Input() status: string;

  @Input() renderStatusName: boolean = true;

  constructor(private elRef: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {

    let color = '#ddd';
    let text = this.status;
    switch (this.status) {
      case 'Open':
        color = 'rgb(88, 196, 58)';
        break;
      case 'Completed':
        color = 'rgb(52, 127, 247)'
        break;
      case 'Enroute':
      case 'Onsite':
      case 'Checked Out':
      case 'Overhead':
        text = 'In Progress';
        color = 'rgb(242, 157, 57)';
        break;
    }

    const el = this.elRef.nativeElement;
    this.renderer.setStyle(el, 'background-color', color);

    if (this.renderStatusName) {
      this.renderer.setProperty(el, 'innerText', text);
    }
  }

}
